import service from '@/utils/axios-v2'

/**
 * 获取保存的路线列表
 * @param {Object} params 
 * eg: {
 *  ifPageAble { Number } 是否分页 0不分页，1分页，默认为0
 *  page { Number } 当前页 默认为1
 *  size { Number } 每页的数量 默认为10
 * }
 */
export function getTripPlanList(params) {
  return service({
    url: '/fleet/route/info/list',
    method: 'get',
    params: params,
    headers: {
      'portal-token': true
    },
    isNotPrompt: true
  })
}

/**
 * 获取保存的路线详情
 * @param { Number } routeId 路线id
 * @param { Object } cancelToken 请求token
 */
export function getTripPlanInfo(routeId, cancelToken) {
  return service({
    url: '/fleet/route/info',
    method: 'get',
    params: { routeId },
    headers: {
      'portal-token': true
    },
    isNotPrompt: true,
    cancelToken
  })
}

// 添加路线
export function addTripPlan(data) {
  return service({
    url: '/fleet/route/add',
    method: 'post',
    data: data,
    headers: {
      'portal-token': true,
      'Content-Type': 'application/json'
    },
    isNotPrompt: true
  })
}

export function editTripPlan(data) {
  return service({
    url: '/fleet/route/info/edit',
    method: 'put',
    data: data,
    headers: {
      'portal-token': true
    },
    isNotPrompt: true
  })
}

export function deleteTripPlan(routeId) {
  return service({
    url: '/fleet/route/info/delete',
    method: 'put',
    params: { routeId },
    headers: {
      'portal-token': true
    },
    isNotPrompt: true
  })
}

export function sendRoute(data) {
  return service({
    url: '/fleet/route/info/share',
    method: 'put',
    data: data,
    headers: {
      'portal-token': true,
      'Content-Type': 'application/json'
    },
    isNotPrompt: true
  })
}

export function getRecentTrips() {
  return service({
    url: '/fleet/route/saved/get',
    method: 'get'
  })
}

export function setRecentTrip(data) {
  return service({
    url: '/fleet/route/save',
    method: 'post',
    data
  })
}

export function getDragPoint(data) {
  return service({
    url: '/fleet/route/drop/point/here',
    method: 'post',
    data,
    isNotPrompt: true
  })
}